import React from "react";
import TrashIcon from "./svgr/Trash";
import FileIcon from "./svgr/Icon";

export const truncateText = (text, maxChars = 10) =>
  text.length > maxChars ? text.slice(0, maxChars) + "..." : text;

const FileComponent = ({
  title,
  size,
  id,
  filterFiles,
  uploading,
  uploadProgress,
}: {
  title: string;
  size: string;
  id: number;
  filterFiles: (id: number) => void;
  uploading: boolean;
  uploadProgress: number | null;
}) => {
  return (
    <div className="file-component">
      <div className="content">
        <div>
          <FileIcon />
          <span>
            <span>{truncateText(`${title}`, 40)}</span>
            <div>
              <span>{`${size} of ${size}.`}</span>
              {uploading ? (
               
                 <svg
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.30005 2.5V4.5"
                    stroke="#355FCD"
                    strokeLinecap="round"
                  />
                  <path
                    d="M8.30005 12.5V14.5"
                    stroke="#355FCD"
                    strokeLinecap="round"
                  />
                  <path
                    d="M14.3 8.5L12.3 8.5"
                    stroke="#355FCD"
                    strokeLinecap="round"
                  />
                  <path
                    d="M4.30005 8.5L2.30005 8.5"
                    stroke="#355FCD"
                    strokeLinecap="round"
                  />
                  <path
                    d="M12.5424 4.25781L11.1282 5.67203"
                    stroke="#355FCD"
                    strokeLinecap="round"
                  />
                  <path
                    d="M5.47207 11.3281L4.05786 12.7423"
                    stroke="#355FCD"
                    strokeLinecap="round"
                  />
                  <path
                    d="M12.5424 12.7423L11.1282 11.3281"
                    stroke="#355FCD"
                    strokeLinecap="round"
                  />
                  <path
                    d="M5.47207 5.67203L4.05786 4.25781"
                    stroke="#355FCD"
                    strokeLinecap="round"
                  />
                </svg>
              ) : (
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.30225 0.833313C12.2603 0.833313 15.4692 4.04226 15.4692 8.00031C15.4691 11.9582 12.2602 15.1663 8.30225 15.1663C4.34432 15.1663 1.13544 11.9582 1.13525 8.00031C1.13525 4.04226 4.34421 0.833313 8.30225 0.833313ZM11.5542 5.34698C11.3775 5.02396 10.972 4.90472 10.6489 5.08136C9.42982 5.74806 8.42242 7.03568 7.74463 8.07355C7.49425 8.45696 7.28007 8.81976 7.10889 9.12726C6.94919 8.97231 6.79039 8.83774 6.64893 8.72589C6.46408 8.57976 6.29764 8.46459 6.17627 8.38507L5.96631 8.25421C5.64648 8.0718 5.23856 8.1834 5.05615 8.50323C4.87399 8.82295 4.98561 9.22999 5.30518 9.41241L5.4458 9.50031C5.5409 9.56261 5.67392 9.65491 5.82178 9.77179C6.12682 10.013 6.45643 10.3298 6.66357 10.6761C6.79067 10.8883 7.025 11.0128 7.27197 10.9993C7.51918 10.9857 7.73929 10.8358 7.84229 10.6107L7.90771 10.4739C7.95283 10.3817 8.01999 10.2465 8.10791 10.0804C8.28425 9.74725 8.54127 9.29141 8.86084 8.80206C9.51635 7.79835 10.3744 6.75124 11.2886 6.25128C11.6116 6.07465 11.7307 5.66999 11.5542 5.34698Z"
                    fill="#4DA167"
                  />
                </svg>
              )}
              <span>{uploading ? "Uploading" : "Completed"}</span>
            </div>
          </span>
        </div>
        <span className="trash" onClick={() => filterFiles(id)}>
          <TrashIcon />
        </span>
      </div>
      {uploading && uploadProgress !== null && (
        <div className="progress-bar-wrapper">
          <div
            className="progress-bar-fill"
            style={{ width: `${uploadProgress}%` }}
          />
        </div>
      )}
    </div>
  );
};

export default FileComponent;
